// extracted by mini-css-extract-plugin
export default {"root":"e4tGiDU12lo1UNbGca-nWQ==","medium":"Em92avMchV4hyssFOYq4PQ==","large":"Ybp7kJsdORA1mlkv0muZwQ=="};